import React, { useEffect, useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import Moment from "moment/moment";

const ApprovedList = ({
  approvedListingForDealer,
  fetchDealerApprovalResponse = [],
  history,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [userId, setUserId] = useState();

  const onPageChange = async (val) => {
    setIsLoading(true);
    setPage(val?.selected + 1);
    await approvedListingForDealer(val?.selected + 1, null, null, 'VERIFIED');
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await approvedListingForDealer(1, null, null, 'VERIFIED');
      setIsLoading(false);
    })();
  }, []);

  const handlePreviousUrl = () => {
    // localStorage.setItem('previous_url', previousPageUrl)
  };

  const handleFilter = async (key, value, stringValue = "") => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const handleSearch = async () => {
    if (searchValue === "") {
      return false;
    }
    setIsLoading(true);
    await approvedListingForDealer(pageNo, searchValue, null, 'VERIFIED');
    setIsLoading(false);
  };

  const removeSearchFilter = async () => {
    delete window.localStorage.search_ucd_dealer;
    setIsLoading(true);
    await approvedListingForDealer();
    setIsLoading(false);
  };

  const handleSubmitFilter = async () => {
    setOpen(false);
    setIsLoading(true);
    await approvedListingForDealer(1, filterInputList);
    setIsLoading(false);
  };

  const handleRemoveFilter = async (key) => {
    if (key !== "") {
      delete filterInputList[0][key];
      setFilterInputList(filterInputList);
      setIsLoading(true);
      await approvedListingForDealer(1, filterInputList);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (isFilterRemove) {
        setFilterInputList([{}]);
        setIsLoading(true);
        await approvedListingForDealer(pageNo, null, null, 'VERIFIED');
        setIsLoading(false);
        setIsRemoveFilter(false);
      }
    })();
  }, [isFilterRemove]);

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Verified List"} history={history} />
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="d-sm-flex align-items-center justify-content-between ">
                  <div className="row col-md-12">
                    <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                      <form className="form-inline mr-auto w-90 navbar-search">
                        <div className="d-flex w-100">
                          <input
                            type="text"
                            className="form-control bg-light border-0 small list-filter"
                            placeholder="Search Dealer..."
                            aria-label="Search"
                            aria-describedby="basic-addon2"
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                          />
                          
                          <div className="btn-search">
                            <button
                              className="btn btn-primary lh-32 border-left-tr-tb"
                              type="button"
                              onClick={(e) => handleSearch()}
                            >
                              <i className="fas fa-search fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/*CARD START*/}
                  {fetchDealerApprovalResponse &&
                    fetchDealerApprovalResponse?.resultSets !== undefined &&
                    fetchDealerApprovalResponse?.resultSets !== [] &&
                    fetchDealerApprovalResponse?.resultSets.map((val, i) => {
                      return (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <div className="card-big-shadow">
                              <div
                                className="card card-just-text"
                                data-background=""
                                data-color=""
                                data-radius="none"

                              >
                                <div className="content">
                                  <h6 className="category mrg-b-12">
                                  {(val?.onboarding_status == 'VERIFIED' || val?.onboarding_status == 'Verified') ? (
                                      <div className="header-ui-item-opp" style={{backgroundColor: 'green'}}>
                                        {val?.onboarding_status}
                                      </div>
                                    ):(
                                      <div className="header-ui-item-opp" style={{backgroundColor: 'red'}}>
                                      {val?.onboarding_status}
                                    </div>
                                    )}
                                    <div
                                      className="dropdown"
                                      style={{ float: "left" }}
                                    >
                                      <i
                                        className="bi bi-three-dots-vertical"
                                        data-toggle="dropdown"
                                        style={{ color: "black" }}
                                      ></i>
                                      <ul className="dropdown-menu">
                                        <li>
                                          <a
                                            href={`ucd-activity-list/${val?.account_id}`}
                                            className="btn btn-sm"
                                            type="button"
                                          >
                                            Activity
                                          </a>
                                        </li>
                                        {(val?.onboarding_status == 'VERIFIED' || val?.onboarding_status == 'Verified') &&
                                            <li>
                                              <a
                                                  href={`ucd-case-list-v2/${val?.dealer_id}/${val?.id}`}
                                                  className="btn btn-sm"
                                                  type="button"
                                              >
                                                Cases
                                              </a>
                                            </li>
                                        }

                                      </ul>
                                    </div>
                                    <div className="row list-view">
                                      {val?.dealer_id && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="fa fa-id-card"></i>
                                            &nbsp;&nbsp;Dealer Id
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.dealer_id}
                                            >
                                              {val?.dealer_id}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      {val?.company_legal_name && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fa fa-tv"></i>
                                            &nbsp;&nbsp;Business Name
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.company_legal_name}
                                            >
                                              {val?.company_legal_name}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i className="fa fa-tv"></i>
                                          &nbsp;&nbsp;Channel Type
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger"
                                            data-tooltip-id="1"
                                            title={val?.channel_type}
                                          >
                                            {val?.channel_type}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fas fa-building"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;Organization Type
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger"
                                            data-tooltip-id="1"
                                            title={val?.dealer_type}
                                          >
                                            {val?.dealer_type}
                                          </span>
                                        </div>
                                      </div>
                                      {val?.gst_no !== null && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-yin-yang"></i>
                                            &nbsp;&nbsp;GST No
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.gst_no}
                                            >
                                              {val?.gst_no}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {val?.pan_no && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i
                                              className="fa fa-id-card"
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;PAN No.
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.pan_no}
                                            >
                                              {val?.pan_no}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fa fa-user"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;Owner Name
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger"
                                            data-tooltip-id="1"
                                            title={val?.owner_name}
                                          >
                                            {val?.owner_name}
                                          </span>
                                        </div>
                                      </div>
                                      {val?.gst_registration && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i
                                              className="fa fa-user-plus"
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;GST Registration.
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.gst_registration}
                                            >
                                              {val?.gst_registration}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      {val?.address && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-building"></i>
                                            &nbsp;&nbsp;Address
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.address}
                                            >
                                              {val?.address}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i className="fas fa-calendar-alt"></i>
                                          &nbsp;&nbsp;Created Date
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                          {Moment(val?.created).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </div>
                                      </div>
                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i className="bi bi-person-check-fill"></i>
                                          &nbsp;&nbsp;Created By
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                          {val?.created_by_user_name}
                                        </div>
                                      </div>
                                      {val?.remark && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-person-check-fill"></i>
                                            &nbsp;&nbsp;Remark
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.remark}
                                          </div>
                                        </div>
                                      )}
                                      {val?.vendor_remark && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-person-check-fill"></i>
                                            &nbsp;&nbsp;Vendor Remark
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.vendor_remark}
                                            >
                                              {val?.vendor_remark}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {val?.account_verification_status && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="bi bi-person-check-fill"></i>
                                              &nbsp;&nbsp;Account Verification Status
                                            </div>
                                            <div className="col-md-6 col-sm-6 l2">
                                            <span
                                                className="trigger"
                                                data-tooltip-id="1"
                                                title={val?.account_verification_status}
                                                style={{color:"red"}}
                                            >
                                              {val?.account_verification_status}
                                            </span>
                                            </div>
                                          </div>
                                      )}
                                    </div>
                                    <hr />
                                    <div className="row list-view-links">
                                      <ul>
                                        <li>
                                          <a
                                            href={`approved-dealer-view/${val?.dealer_id}`}
                                            onClick={handlePreviousUrl}
                                          >
                                            <i
                                              className="fa fa-tasks"
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;View
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  {fetchDealerApprovalResponse &&
                    fetchDealerApprovalResponse?.resultSets !== undefined &&
                    fetchDealerApprovalResponse?.resultSets.length > 0 && (
                      <div className="panel-pagination-col panel-table-pagination">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={
                            fetchDealerApprovalResponse?.total /
                            fetchDealerApprovalResponse?.per_page
                          }
                          forcePage={
                            fetchDealerApprovalResponse?.current_page - 1
                          }
                          pageRangeDisplayed={4}
                          onPageChange={onPageChange}
                          activeClassName={"active"}
                        />
                      </div>
                    )}
                  {fetchDealerApprovalResponse &&
                    fetchDealerApprovalResponse?.resultSets !== undefined &&
                    fetchDealerApprovalResponse?.resultSets.length === 0 && (
                      <>
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt={""}
                          style={{ maxWidth: "100%" }}
                        />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                        {/* <div className="col-sm-6">
                          <a href={`ucd-dealer-verify`} className="draft-float">
                            <p
                              className="my-float"
                              style={{ marginTop: "20px" }}
                            >
                              <i className="fa fa-plus" aria-hidden="true"></i>
                            </p>
                          </a>
                        </div> */}
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*<BottomMenu*/}
        {/*    open={open}*/}
        {/*    setOpen={setOpen}*/}
        {/*    handleSubmitFilter={handleSubmitFilter}*/}
        {/*    filterContent={fetchDealerApprovalResponse}*/}
        {/*    handleFilter={handleFilter}*/}
        {/*    setIsRemoveFilter={setIsRemoveFilter}*/}
        {/*/>*/}
      </div>
      {/* section ends */}
    </>
  );
};

export default ApprovedList;
